import { createContext, useContext, useEffect, useState } from "react";

import { Session } from "@supabase/supabase-js";
import { supabase } from "@/core/services/supabase-client";
import { useProfileQuery, type Profile } from "@/shared/hooks/queries/use-profile-query";

const SessionContext = createContext<{
  session: Session | null;
  profile: Profile | null;
}>({
  session: null,
  profile: null,
});

export const useSession = () => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error("useSession must be used within a SessionProvider");
  }
  return context;
};

type Props = { children: React.ReactNode };
export const SessionProvider = ({ children }: Props) => {
  const [session, setSession] = useState<Session | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const { data: profile } = useProfileQuery(session?.user ?? null);

  useEffect(() => {
    const authStateListener = supabase.auth.onAuthStateChange(async (_, session) => {
      setSession(session);
      setIsLoading(false);
    });

    return () => {
      authStateListener.data.subscription.unsubscribe();
    };
  }, [supabase]);

  return (
    <SessionContext.Provider value={{ session, profile: profile ?? null }}>
      {isLoading ? <div>cargando...</div> : children}
    </SessionContext.Provider>
  );
};
